import Raven from 'raven-js';
import { convertTimePointToMomentDate, isAfterDateOperation, isAfterPropertyOperation, isBeforeDateOperation, isBeforePropertyOperation, isBetweenDatesOperation, isEqualToDateOperation, isLessThanXDaysAgoOperation, isLessThanXDaysFromNowOperation, isMoreThanXDaysAgoOperation, isMoreThanXDaysFromNowOperation, isNotBetweenDatesOperation, isNotUpdatedInLastXDaysOperation, isUpdatedAfterPropertyOperation, isUpdatedBeforePropertyOperation, isUpdatedInLastXDaysOperation } from 'flow-doctor-lib/utils/timePointUtils';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { TIMESTAMP_DATE_FORMAT } from 'flow-doctor-lib/constants/Global';
import { jsx as _jsx } from "react/jsx-runtime";
export const TimePointDisplayLabel = ({
  propertyName,
  operation
}) => {
  if (isAfterDateOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_AFTER_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_AFTER',
      options: {
        propertyName,
        propertyValue: convertTimePointToMomentDate(operation.timePoint).format(TIMESTAMP_DATE_FORMAT)
      }
    });
  }
  if (isBeforeDateOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_BEFORE_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_BEFORE',
      options: {
        propertyName,
        propertyValue: convertTimePointToMomentDate(operation.timePoint).format(TIMESTAMP_DATE_FORMAT)
      }
    });
  }
  if (isMoreThanXDaysAgoOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_MORE_THAN_X_DAYS_AGO_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_MORE_THAN_X_DAYS_AGO',
      options: {
        propertyName,
        propertyValue: Math.abs(operation.timePoint.offset.days)
      }
    });
  }
  if (isMoreThanXDaysFromNowOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_MORE_THAN_X_DAYS_FROM_NOW_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_MORE_THAN_X_DAYS_FROM_NOW',
      options: {
        propertyName,
        propertyValue: operation.timePoint.offset.days
      }
    });
  }
  if (isAfterPropertyOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_AFTER_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_AFTER',
      options: {
        propertyName,
        propertyValue: operation.timePoint.property
      }
    });
  }
  if (isBeforePropertyOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_BEFORE_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_BEFORE',
      options: {
        propertyName,
        propertyValue: operation.timePoint.property
      }
    });
  }
  if (isUpdatedAfterPropertyOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_AFTER_PROPERTY_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_AFTER_PROPERTY',
      options: {
        propertyName,
        propertyValue: operation.timePoint.property
      }
    });
  }
  if (isUpdatedBeforePropertyOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_BEFORE_PROPERTY_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_BEFORE_PROPERTY',
      options: {
        propertyName,
        propertyValue: operation.timePoint.property
      }
    });
  }
  Raven.captureMessage('Found unknown `timepoint` operation', {
    extra: {
      propertyName,
      operation
    }
  });
  return null;
};
export const RangedTimeDisplayLabel = ({
  propertyName,
  operation
}) => {
  if (isEqualToDateOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_EQUAL_TO_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_EQUAL_TO',
      options: {
        propertyName,
        propertyValue: convertTimePointToMomentDate(operation.lowerBoundTimePoint).format(TIMESTAMP_DATE_FORMAT)
      }
    });
  }
  if (isBetweenDatesOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_BETWEEN_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_BETWEEN',
      options: {
        propertyName,
        firstValue: convertTimePointToMomentDate(operation.lowerBoundTimePoint).format(TIMESTAMP_DATE_FORMAT),
        secondValue: convertTimePointToMomentDate(operation.upperBoundTimePoint).format(TIMESTAMP_DATE_FORMAT)
      }
    });
  }
  if (isNotBetweenDatesOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_NOT_BETWEEN_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_NOT_BETWEEN',
      options: {
        propertyName,
        firstValue: convertTimePointToMomentDate(operation.lowerBoundTimePoint).format(TIMESTAMP_DATE_FORMAT),
        secondValue: convertTimePointToMomentDate(operation.upperBoundTimePoint).format(TIMESTAMP_DATE_FORMAT)
      }
    });
  }
  if (isLessThanXDaysAgoOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_LESS_THAN_X_DAYS_AGO_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_LESS_THAN_X_DAYS_AGO',
      options: {
        propertyName,
        propertyValue: Math.abs(operation.lowerBoundTimePoint.offset.days)
      }
    });
  }
  if (isLessThanXDaysFromNowOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.IS_LESS_THAN_X_DAYS_FROM_NOW_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.IS_LESS_THAN_X_DAYS_FROM_NOW',
      options: {
        propertyName,
        propertyValue: Math.abs(operation.upperBoundTimePoint.offset.days)
      }
    });
  }
  if (isUpdatedInLastXDaysOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.UPDATED_IN_LAST_X_DAYS_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.UPDATED_IN_LAST_X_DAYS',
      options: {
        propertyName,
        propertyValue: Math.abs(operation.lowerBoundTimePoint.offset.days)
      }
    });
  }
  if (isNotUpdatedInLastXDaysOperation(operation)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: operation.includeObjectsWithNoValueSet || operation.defaultValue != null ? 'flow-doctor-lib.filters.property.operators.NOT_UPDATED_IN_LAST_X_DAYS_WITH_EMPTY' : 'flow-doctor-lib.filters.property.operators.NOT_UPDATED_IN_LAST_X_DAYS',
      options: {
        propertyName,
        propertyValue: Math.abs(operation.lowerBoundTimePoint.offset.days)
      }
    });
  }
  Raven.captureMessage('Found unknown `rangedtime` operation', {
    extra: {
      propertyName,
      operation
    }
  });
  return null;
};